export const CouponData = [
  {
    id:"1",
    Name: "New Year Blast",
    Code: "NEWYEAR30",
    Description: "30% off on New Year",
    Type: "Percentage",
    Discount: "30%",
    Limit: "01",
    Valid: "04 Jan 2025",
    Status: "Active",
  },
  {
    id:"2",
    Name: "Christmas Cheer",
    Code: "CHRISTMAS100",
    Description: "$100 off holiday packages",
    Type: "Fixed Amount",
    Discount: "$100",
    Limit: "01",
    Valid: "27 Dec 2024",
    Status: "Active",
  },
  {
    id:"3",
    Name: "Spooky Savings",
    Code: "HALLOWEEN20",
    Description: "20% off on Halloween items",
    Type: "Percentage",
    Discount: "20%",
    Limit: "02",
    Valid: "28 Nov 2024",
    Status: "Active",
  },
  {
    id:"4",
    Name: "Black Friday",
    Code: "BLACKFRIDAY50",
    Description: "50% off electronics",
    Type: "Percentage",
    Discount: "50%",
    Limit: "04",
    Valid: "18 Nov 2024",
    Status: "Inactive",
  },
  {
    id:"5",
    Name: "Golden Years Deal",
    Code: "SENIOR20",
    Description: "20% off for senior citizens",
    Type: "Percentage",
    Discount: "20%",
    Limit: "03",
    Valid: "06 Nov 2024",
    Status: "Active",
  },
  {
    id:"6",
    Name: "Thanksgiving Special",
    Code: "THANKS10",
    Description: "10% off for Thanksgiving",
    Type: "Percentage",
    Discount: "10%",
    Limit: "01",
    Valid: "31 Oct 2024",
    Status: "Active",
  },
  {
    id:"7",
    Name: "New Year Blast",
    Code: "STUDENT10",
    Description: "10% off for students",
    Type: "Percentage",
    Discount: "10%",
    Limit: "02",
    Valid: "14 Oct 2024",
    Status: "Active",
  },
  {
    id:"8",
    Name: "Big Saver Deal",
    Code: "SAVE50",
    Description: "$50 off orders over $300",
    Type: "Fixed Amount",
    Discount: "$50",
    Limit: "03",
    Valid: "03 Oct 2024",
    Status: "Inactive",
  },
  {
    id:"9",
    Name: "Weekend Exclusive",
    Code: "WEEKENDSALE",
    Description: "Exclusive15% off on weekends",
    Type: "Percentage",
    Discount: "15%",
    Limit: "04",
    Valid: "29 Sep 2024",
    Status: "Active",
  },
  {
    id:"10",
    Name: "Welcome Delight",
    Code: "WELCOME10",
    Description: "10% off for first-time users",
    Type: "Percentage",
    Discount: "10%",
    Limit: "01",
    Valid: "10 Sep 2024",
    Status: "Active",
  },
  {
    id:"11",
    Name: "New Year Blast",
    Code: "NEWYEAR30",
    Description: "30% off on New Year",
    Type: "Percentage",
    Discount: "30%",
    Limit: "01",
    Valid: "04 Jan 2025",
    Status: "Active",
  },
  {
    id:"12",
    Name: "Christmas Cheer",
    Code: "CHRISTMAS100",
    Description: "$100 off holiday packages",
    Type: "Fixed Amount",
    Discount: "$100",
    Limit: "01",
    Valid: "27 Dec 2024",
    Status: "Active",
  },
  {
    id:"13",
    Name: "Spooky Savings",
    Code: "HALLOWEEN20",
    Description: "20% off on Halloween items",
    Type: "Percentage",
    Discount: "20%",
    Limit: "02",
    Valid: "28 Nov 2024",
    Status: "Active",
  },
  {
    id:"15",
    Name: "Black Friday",
    Code: "BLACKFRIDAY50",
    Description: "50% off electronics",
    Type: "Percentage",
    Discount: "50%",
    Limit: "04",
    Valid: "18 Nov 2024",
    Status: "Inactive",
  },
  {
    id:"16",
    Name: "Golden Years Deal",
    Code: "SENIOR20",
    Description: "20% off for senior citizens",
    Type: "Percentage",
    Discount: "20%",
    Limit: "03",
    Valid: "06 Nov 2024",
    Status: "Active",
  },
  {
    id:"17",
    Name: "Thanksgiving Special",
    Code: "THANKS10",
    Description: "10% off for Thanksgiving",
    Type: "Percentage",
    Discount: "10%",
    Limit: "01",
    Valid: "31 Oct 2024",
    Status: "Active",
  },
];
